import { n as getFriend } from "../../../../chunks/api.js";
async function load({ params, locals }) {
  const data = await getFriend(params.id, locals.currentUser);
  return {
    ...data,
    ...locals
  };
}
export {
  load
};
